module.exports = __webpack_public_path__ + "img/Z82_09.7bea61cc.jpg";